module.exports = __webpack_public_path__ + "static/img/bg.730501a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bg.jpg
// module id = 0f+U
// module chunks = 1